import { styled } from '@mui/material/styles';
import { NodeData } from './types';

export const Node = styled('div')({
  position: 'relative',

  height: 'fit-content',
  padding: '20px 8px',

  fontSize: '14px',

  borderRadius: '8px',

  transition: 'all 300ms ease-in-out',

  '&:hover': {
    '.tooltip': {
      opacity: 1,
      visibility: 'visible',
    },
  },
});

export const Label = styled('p')({
  margin: '0',
  fontWeight: '600',
});

const setTooltipPositionStyles = (props: { position: NodeData['tooltipProps']['position'] }) => {
  return TOOLTIP_POSITION[props.position];
};

export const Tooltip = styled('div')`
  opacity: 0;
  visibility: hidden;
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: max-content;
  max-width: 350px;
  max-height: 250px;
  padding: 8px 12px;

  font-size: 12px;
  text-align: start;
  color: white;
  background-color: black;
  line-height: 1.375;
  font-weight: 400;
  white-space: pre-wrap;

  border-radius: 4px;
  z-index: 50;

  transition: all 300ms ease-in-out;

  ${setTooltipPositionStyles}
`;

export const TooltipDetails = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  overflow: auto;

  p {
    margin: 0;
  }
`;

const tooltipPositionAfterCommonProps = `
  content: "";
  position: absolute;
  border: 6px solid;
`;

const topPositionAfterCommonStyles = `
  ${tooltipPositionAfterCommonProps}
  top: 100%;
  border-color: black transparent transparent transparent;
`;

const bottomPositionAfterCommonStyles = `
  ${tooltipPositionAfterCommonProps}
  bottom: 100%;
  border-color: transparent transparent black transparent;
`;

const TOOLTIP_POSITION: Record<NodeData['tooltipProps']['position'], string> = {
  top_left: `
    bottom: 110%;
    left: 12px;
    
    &::after {
      left: 12px;
      margin-left: -8px;
      ${topPositionAfterCommonStyles}
    }
  `,
  top_right: `
    bottom: 110%;
    right: 12px;

    &::after {
      right: 12px;
      margin-right: -8px;
      ${topPositionAfterCommonStyles}
    }
  `,
  bottom_left: `
    top: 100%;
    left: 12px;

    &::after {
      left: 12px;
      margin-left: -8px;
      ${bottomPositionAfterCommonStyles}
    }
  `,
  bottom_right: `
    top: 100%;
    right: 12px;

    &::after {
      right: 12px;
      margin-right: -8px;
      ${bottomPositionAfterCommonStyles}
    }
  `,
};
